import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { PaginationButton } from './PaginationButton';
import type { UsePaginationReturn } from '@/shared/types/pagination';

type PaginationControlsProps = Pick<
  UsePaginationReturn,
  | 'pageIndex'
  | 'visiblePages'
  | 'canPrevious'
  | 'canNext'
  | 'goToPage'
  | 'next'
  | 'previous'
  | 'first'
  | 'last'
>;

export function PaginationControls({
  pageIndex,
  visiblePages,
  canPrevious,
  canNext,
  goToPage,
  next,
  previous,
  first,
  last,
}: PaginationControlsProps) {
  const { t } = useTranslation('pagination');

  return (
    <div className="flex items-center gap-1">
      <PaginationButton
        isDisabled={!canPrevious}
        onClick={first}
        tooltip={t('first')}
        variant="ghost"
        size="icon"
      >
        <ChevronsLeft className="h-4 w-4" />
      </PaginationButton>

      <PaginationButton
        isDisabled={!canPrevious}
        onClick={previous}
        tooltip={t('previous')}
        variant="ghost"
        size="icon"
      >
        <ChevronLeft className="h-4 w-4" />
      </PaginationButton>

      {visiblePages.map((page) => (
        <PaginationButton
          key={page}
          isActive={page === pageIndex}
          onClick={() => goToPage(page)}
          variant={page === pageIndex ? 'default' : 'outline'}
          size="sm"
        >
          {page + 1}
        </PaginationButton>
      ))}

      <PaginationButton
        isDisabled={!canNext}
        onClick={next}
        tooltip={t('next')}
        variant="ghost"
        size="icon"
      >
        <ChevronRight className="h-4 w-4" />
      </PaginationButton>

      <PaginationButton
        isDisabled={!canNext}
        onClick={last}
        tooltip={t('last')}
        variant="ghost"
        size="icon"
      >
        <ChevronsRight className="h-4 w-4" />
      </PaginationButton>
    </div>
  );
}
